var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import ActionTypes from "./ActionTypes.js";
const defaultSubState = {
  items: {}
};
const updateActiveProgressionListPropsData = (state, actionResult) => {
  var _a;
  const { id, props } = actionResult.payload;
  return __spreadProps(__spreadValues({}, state), {
    items: __spreadProps(__spreadValues({}, state.items), {
      [id]: __spreadProps(__spreadValues(__spreadValues({}, state.items[id]), props), {
        visible: __spreadValues(__spreadValues({}, (_a = state == null ? void 0 : state.items[id]) == null ? void 0 : _a.visible), props.visible)
      })
    })
  });
};
const ActiveProgressionsExpandListPropsReducer = (state = defaultSubState, actionResult) => {
  switch (actionResult.type) {
    case ActionTypes.UPDATE_ACTIVE_PROGRESSION_LIST_PROPS_DATA:
      return updateActiveProgressionListPropsData(state, actionResult);
    default:
      return state;
  }
};
export {
  ActiveProgressionsExpandListPropsReducer,
  ActiveProgressionsExpandListPropsReducer as default
};
//# sourceMappingURL=ActiveProgressionsListPropsReducer.js.map
